import CryptoJS from 'crypto-js';
import AppConfig from "../config/index";
import { message } from 'antd';
// 生成加密的key
function GetKey() {
  // 生成一个基于当前日期和静态字符串的值
  const value = AppConfig.REACT_APP_WEB_KEY;
  // 使用MD5对该值进行哈希
  const key = CryptoJS.MD5(value).toString();
  return key;
}

// 加密函数
export function encrypt(secret) {
  try {
    // 检查secret是否为对象，如果是则转换为JSON字符串
    const secretString = typeof secret === 'object' ? JSON.stringify(secret) : secret;
    // 使用AES对secretString进行加密，key由GetKey()生成
    const encrypted = CryptoJS.AES.encrypt(secretString, GetKey());
    return encrypted.toString();
  } catch (e) {
    console.error(e);
    return '';
  }
}

// 解密函数
export function decrypt(encrypted) {
  if (encrypted) {
    try {
      // 使用AES对encrypted进行解密，key由GetKey()生成
      const decrypted = CryptoJS.AES.decrypt(encrypted, GetKey()).toString(CryptoJS.enc.Utf8);
      if (decrypted) {
        // 尝试将解密后的字符串解析为JSON对象
        if (decrypted[0] === "{" && decrypted[decrypted.length - 1] === "}") {
          return JSON.parse(decrypted);
        } else {
          return decrypted;
        }
        // return typeof secret === 'object'? JSON.parse(decrypted): decrypted;
      } else {
        return '';
      }
    } catch (e) {
      localStorage.clear();
      setTimeout(() => {
        message.error('Storage expired, please login again.');
      }, 1500);
      window.location.href = "login";
      console.error(e);
    }
  }
  return '';
}

// 解密并返回key
// export function decryptStr() {
//   // 从localStorage中获取'subScription'项
//   const str_key = localStorage.getItem('8445ca2a93e1') || null;
//   if (str_key) {
//     // 如果找到了'subScription'项，对其进行解密
//     const secretkey = decrypt(str_key);
//     if (secretkey) {
//       // 如果解密成功，从解密后的对象中提取两个属性
//       const COG_SERVICE_KEY = secretkey.REACT_APP_COG_SERVICE_KEY;
//       const COG_SERVICE_LOCATION = secretkey.REACT_APP_COG_SERVICE_LOCATION;

//       return {
//         COG_SERVICE_KEY,
//         COG_SERVICE_LOCATION
//       };
//     } else {
//       console.error('Decryption failed');
//     }
//   } else {
//     console.error('Not find subScription key');
//     // 如果没有找到'subScription'项，清空localStorage并重定向到登录页面
//     localStorage.clear();
//     setTimeout(() => {
//       window.location.href = "login";
//       console.error('not found subScription key');
//     }, 1500);
//     return {
//       COG_SERVICE_KEY: null,
//       COG_SERVICE_LOCATION: null
//     };
//   }
// }
